import React, { FC } from "react";
import { Table } from "flowbite-react";

interface OwnProps<T = any> {
	headings: T;
	cellData: T[];
}

const SiteTable: FC<OwnProps> = ({ cellData, headings }: OwnProps) => (
	<div className="mt-4 mb-4 w-full overflow-x-auto rounded-xl border-2 border-blue">
		<Table>
			<Table.Head>
				{Object.entries(headings).map((heading: any) => (
					<Table.HeadCell key={heading[0]}>{heading[1]}</Table.HeadCell>
				))}
			</Table.Head>
			<Table.Body className="divide-y">
				{cellData.map((cell) => (
					<Table.Row
						key={cell.cookie}
						className="bg-white dark:border-gray-700 dark:bg-gray-800"
					>
						{Object.entries(cell).map((c, i) => (
							<Table.Cell
								key={i}
								className={`${
									i === 0
										? "whitespace-nowrap font-medium text-gray-900 dark:text-white"
										: null
								}`}
							>
								{`${c[1]}`}
							</Table.Cell>
						))}
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	</div>
);

export default SiteTable;
